import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space8,
    overflowY: "scroll",
    maxHeight: 194,
    marginTop: theme.spacing.space12,
    borderRadius: theme.radius.small,
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    outline: "none",
  },
  noti: {
    background: theme.colors.Background3,
  },
  btn: {
    marginTop: theme.spacing.space20,
  },
}));
